import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { Subscription } from 'rxjs';
import { PrimaryButtonComponent } from '../../basic/buttons/primary-button/primary-button.component';
import { BoardService } from '../../core/board/board.service';
import { StripeProductType } from '../../core/stripe/product.stripe';
import { Task } from '../../core/task/task';
import { TaskService } from '../../core/task/task.service';
import { WorkspaceHolderService } from '../../core/workspace/workspace.holder.service';
import { UpgradeToPremiumComponent } from '../../domain/membership/upgrade-to-premium/upgrade-to-premium.component';
import { ProfileCardComponent } from '../../domain/profile-card/profile-card.component';
import { SalesCycleBarComponent } from '../../domain/sales-cycle/sales-cycle-bar/sales-cycle-bar.component';
import { NewEditSessionTemplateComponent } from '../../domain/session-template/new-edit-session-template/new-edit-session-template.component';
import { NewSurveySessionTemplateComponent } from '../../domain/session-template/new-survey-session-template/new-survey-session-template.component';
import { SessionTemplateCardComponent } from '../../domain/session-template/session-template-card/session-template-card.component';
import { NewScenarioTaskComponent } from '../../domain/task/new-scenario-task/new-scenario-task.component';
import { ScenarioTaskCardComponent } from '../../domain/task/scenario-task-card/scenario-task-card.component';
import { BasicPageComponent } from '../_shared/basic-page/basic-page.component';

@Component({
  selector: 'app-events',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,

    MatTooltipModule,
    NzButtonModule,
    NzTagModule,
    NzTabsModule,
    NzSkeletonModule,

    UpgradeToPremiumComponent,
    BasicPageComponent,
    ProfileCardComponent,
    NewEditSessionTemplateComponent,
    PrimaryButtonComponent,
    NewSurveySessionTemplateComponent,
    SessionTemplateCardComponent,
    SalesCycleBarComponent,
    NewScenarioTaskComponent,
    ScenarioTaskCardComponent,
  ],
  templateUrl: './assignments.component.html',
  styleUrl: './assignments.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssignmentsComponent {
  isAddScenarioTaskVisible = false;
  onAddLeaderBoardClick() {
    this.isAddScenarioTaskVisible = true;
  }

  personalBoardList = toSignal(this.boardService.getAllUserList$());

  isLoadingTaskList = signal(true);

  taskList = signal<Task[]>([]);

  tastListSubscription?: Subscription;

  selectedTabIndex: number = 0;

  StripeProductType = StripeProductType;

  constructor(
    private taskService: TaskService,
    private boardService: BoardService,
    private workspaceHolderService: WorkspaceHolderService
  ) {}

  ngOnInit() {
    const boardIdList = (this.personalBoardList() ?? []).map((c) => c.id);
    this.tastListSubscription = this.taskService.getTaskList$(boardIdList).subscribe((data) => {
      this.taskList.set((data ?? []) as Task[]);
      this.isLoadingTaskList.set(false);
    });
  }

  ngOnDestroy() {
    this.tastListSubscription?.unsubscribe();
  }

  paidStatus = computed(() => {
    const paidStatus = this.workspaceHolderService.paidStatus();
    return paidStatus;
  });

  boardIdList = computed(() => (this.personalBoardList() ?? []).map((c) => c.id));
}
